// extracted by mini-css-extract-plugin
export default {"container":"FlowRunCountSummary_container__39MkI","summaryLabel":"FlowRunCountSummary_summaryLabel__3emuH","info":"FlowRunCountSummary_info__3zY6N"};